import { breakpoints, QuantitySelector } from '@notino/react-styleguide';

import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const BuyButtons = styled.div`
  display: grid;
  grid-gap: 0.5rem;
  align-items: center;
  width: 100%;
  padding: 1rem 0 1.5rem;
  grid-template-areas: 'addToCart';
`;

export const StickyPlaceholder = styled.div`
  grid-area: addToCart;
  height: 1px;
  width: 100%;
  pointer-events: none;

  @media (min-width: ${breakpoints.md}) {
    display: none;
  }
`;

export const stickyBuyButtons = css`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  z-index: 100;
  padding: 1rem;
  box-shadow: 0 -1px 2px 0 rgba(71, 71, 71, 0.04),
    0 -2px 4px 0 rgba(71, 71, 71, 0.08);
  transition: box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out;

  @media (min-width: ${breakpoints.md}) {
    position: static;
    background-color: transparent;
    z-index: auto;
    padding: 0;
    box-shadow: none;
    transition: none;
  }
`;

export const stickyHidden = css`
  transform: translateY(100%);
`;

export const clickAndCollectGridTemplateAread = css`
  grid-template-areas:
    'addToCart'
    'clickAndCollect';
`;

export const ButtonWrapper = styled.div`
  & > button,
  form button {
    padding: 0 0.5625rem !important;
    height: 2.75rem;
    min-width: 7.5rem;
    text-transform: none !important;
    font-weight: normal !important;
  }
  flex: 1;
  min-width: 7.5rem;

  & > button,
  form button {
    height: 3.25rem;
  }
`;

export const Label = styled.label`
  display: none;
`;

export const DropdownButtonSeparator = styled.div`
  padding-right: 0.5rem;
`;

export const QuantityWrapper = styled.div`
  width: 5.25rem;
  font-size: 0.875rem;
  & > div > div {
    min-height: 2.75rem;

    &:focus-visible {
      outline: 2px solid #007bff;
      outline-offset: 2px;
    }
  }
`;

interface IWrapperProps {
  isClickAndCollect?: boolean;
  canBuy?: boolean;
}

export const AddToCartWrapper = styled.div<IWrapperProps>`
  grid-area: addToCart;

  display: flex;
  align-items: center;
`;

export const ClickAndCollectWrapper = styled.div<IWrapperProps>`
  grid-area: clickAndCollect;
  margin-top: ${({ isClickAndCollect }) =>
    isClickAndCollect ? '-0.5rem' : '0'};

  @media (min-width: ${breakpoints.sm}) {
    margin-top: 0;
  }
`;

export const StyledQuantitySelector = styled(QuantitySelector)`
  [role='combobox'] {
    height: 3.25rem;
  }
`;
